const Home = () => {
  return <h1>Welcome to ShopZone 🛒</h1>;
};

export default Home;